import React from 'react';
import { PageHeader, DarkPanel } from '../components/ui';

export default function Education() {
  return (
    <div className="space-y-4 pb-8">
      <PageHeader title="Education" subtitle="Short primers to help you understand signals on this platform." />

      <DarkPanel title="What is the stock market?">
        <p className="text-sm leading-relaxed text-slate-300">
          The stock market is where shares of publicly traded companies are bought and sold.
          A share represents partial ownership in a company. Prices move based on supply and demand,
          company news, earnings, and overall market sentiment.
        </p>
      </DarkPanel>

      <DarkPanel title="Stock buy vs sell">
        <ul className="list-disc space-y-2 pl-5 text-sm leading-relaxed text-slate-300">
          <li>
            <strong className="text-emerald-300">Buy (long):</strong> You purchase shares expecting
            the price to rise. Profit comes if you later sell higher than your entry.
          </li>
          <li>
            <strong className="text-rose-300">Sell (short or exit):</strong> Selling can mean closing
            a long position to lock gains/cut losses, or shorting when you expect the price to fall.
            Signals on this app label direction clearly for each idea.
          </li>
          <li>
            <strong className="text-white">Stop loss / targets:</strong> Planned exit levels if price moves against you
            (stop) or in your favor (targets).
          </li>
        </ul>
      </DarkPanel>

      <DarkPanel title="Options: call and put">
        <p className="mb-3 text-sm leading-relaxed text-slate-300">
          An option is a contract tied to an underlying stock. You pay a <strong className="text-white">premium</strong>{' '}
          (the option price). Strike and expiry define the contract terms.
        </p>
        <ul className="list-disc space-y-2 pl-5 text-sm leading-relaxed text-slate-300">
          <li>
            <strong className="text-emerald-300">Call:</strong> Bullish contract. A long call can
            gain value if the stock rises above the strike (and time/volatility help). P/L on this
            app is based on the <em>option premium</em>, not the stock price alone.
          </li>
          <li>
            <strong className="text-rose-300">Put:</strong> Bearish contract. A long put can gain
            value if the stock falls. Again, gains/losses track the option premium.
          </li>
          <li>
            <strong className="text-white">Expiry:</strong> After expiration, the contract ends. Value can go to zero if
            it finishes out of the money.
          </li>
        </ul>
      </DarkPanel>

      <div className="rounded-2xl border border-amber-200 bg-amber-50 p-4 text-sm leading-relaxed text-amber-950/90">
        <p className="mb-1 font-semibold text-amber-900">Educational only</p>
        <p>
          This content is for learning. It is not a recommendation to buy or sell any security.
          Trading stocks and options involves risk of loss.
        </p>
      </div>
    </div>
  );
}
